import React from "react";
import { useIntl } from "react-intl";
import { Promo } from "../Promo/Promo";
import _ from "lodash";
import { useQuery } from "@apollo/client";
import { GET_BRAND } from "../../../views/BrandView/brandViewConfig";
import { brands } from "../../../config/brands";
import { apiDomain, apiSiteId } from "../../../config";

export const PromoBrand = ({ brandId }) => {
  const intl = useIntl();
  const locale = intl.locale;
  const brand =
    brandId == null
      ? _.sample(brands.filter((b) => [1, 2].includes(b.pillar)))
      : brands.find((brand) => brand.id === brandId);

  const {
    loading: brandLoading,
    error: brandError,
    data: brandData,
  } = useQuery(GET_BRAND, {
    variables: {
      id: brand?.id,
      locale,
    },
  });

  const data = brandData?.brand?.findById;
  const block1ImgSrc =
    data?.block_1?.image?.media?._id != null
      ? `https://${apiDomain}/${apiSiteId}/asset/${data?.block_1?.image?.media?._id}?type=fill&width=2800&height=1300`
      : "https://picsum.photos/id/58/1862/938";
  const block1ImgMobileSrc =
    data?.block_1?.imageMobile?.media?._id != null
      ? `https://${apiDomain}/${apiSiteId}/asset/${data?.block_1?.imageMobile?.media?._id}?type=fill&width=2800&height=1300`
      : "https://picsum.photos/id/58/1862/938";

  return brandLoading ? null : (
    <Promo
      image={
        <picture>
          {block1ImgMobileSrc && (
            <source media="(max-width: 1023px)" srcSet={block1ImgMobileSrc} />
          )}
          <img src={block1ImgSrc} alt={brand.label} />
        </picture>
      }
      title={data?.block_1?.title}
      desc={data?.block_1?.desc}
      ctaUrl={data?.block_1?.ctaUrl}
    />
  );
};
